module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.7e367be02cd17a96d513.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = 1375
// module chunks = 2